import { render, staticRenderFns } from "./DialogWarning.vue?vue&type=template&id=afe4d930&scoped=true&"
import script from "./DialogWarning.vue?vue&type=script&lang=js&"
export * from "./DialogWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe4d930",
  null
  
)

export default component.exports